import { render, staticRenderFns } from "./SaleReferences.vue?vue&type=template&id=5d2654c2&scoped=true"
import script from "./SaleReferences.vue?vue&type=script&lang=ts"
export * from "./SaleReferences.vue?vue&type=script&lang=ts"
import style0 from "./SaleReferences.vue?vue&type=style&index=0&id=5d2654c2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2654c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d2654c2')) {
      api.createRecord('5d2654c2', component.options)
    } else {
      api.reload('5d2654c2', component.options)
    }
    module.hot.accept("./SaleReferences.vue?vue&type=template&id=5d2654c2&scoped=true", function () {
      api.rerender('5d2654c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sales/SaleReferences.vue"
export default component.exports